export { RegisterComponent } from './register.component';
export { RegisterService } from './register.service';
export { EmailValidatorDirective } from './email-validator.directive';
